import React from "react";

const MyAccount = () => {
  return (
    <div className="my-24 md:px-14  max-w-screen-2xl mx-auto ">MyAccount</div>
  )
}

export default MyAccount